import ReadMoreButton from '../../../components/buttons/readMoreButton/readMoreButton';
import NormalText from '../../../components/text/normalText';
import './equipamentCardStyle.css';

export default function EquipamentCard({equipament}) {
    return (
        <article className='equipament-card__container'>
            <h1 className='equipament-card__title'>{equipament.name}</h1>
            <img className='equipament-card__photo' src={equipament.photo} />
            <NormalText text={equipament.summary}  elipses={true} />
            <ReadMoreButton url={`/equipaments/${equipament.id}`} />
        </article>
    );
}
